import React from 'react';

const MobileIwocaLogo = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.662 24.0004H1.34807C0.602545 24.0004 0 23.3979 0 22.6523V1.34812C0 0.602572 0.602545 0 1.34807 0H22.6518C23.3973 0 23.9999 0.602572 23.9999 1.34812V22.6523C24.0101 23.3979 23.4075 24.0004 22.662 24.0004ZM2.70637 21.294H21.3139V2.68601H2.70637V21.294Z"
            fill="#FB534A"
        />
        <path
            d="M16.9736 11.5819V7.7316C16.9736 7.53756 16.7796 7.40479 16.5957 7.47628L14.4409 8.37501C14.3387 8.41586 14.2775 8.51799 14.2775 8.63033V15.3709C14.2775 15.4832 14.3387 15.5751 14.4409 15.6262L16.5957 16.5249C16.7796 16.5964 16.9736 16.4739 16.9736 16.2696V11.5819Z"
            fill="#FB534A"
        />
        <path
            d="M9.73266 8.63033V15.3709C9.73266 15.4832 9.67138 15.5751 9.56926 15.6262L7.41437 16.5249C7.23054 16.5964 7.0365 16.4739 7.0365 16.2696V7.7316C7.0365 7.53756 7.23054 7.40479 7.41437 7.47628L9.56926 8.37501C9.66117 8.41586 9.73266 8.51799 9.73266 8.63033Z"
            fill="#FB534A"
        />
    </svg>
);

export default MobileIwocaLogo;
